package com.sddamico.swigmore.models

import kotlinx.serialization.Serializable

@Serializable
data class SuccessResponse(val message: String)
